import { render, staticRenderFns } from "./zugriffsrechte.vue?vue&type=template&id=e99e946c&"
import script from "./zugriffsrechte.vue?vue&type=script&lang=js&"
export * from "./zugriffsrechte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports